import { IbhFilterKeys } from '@hub/libs/constants';
import { FilterRangeInput } from '@hub/common/inputs/FilterRangeInput';
import type { IbhDimensions } from '@hub/bearing-hub/common/dimensions/dimensions';
import { getUnitLabelForUnitSystem, TemperatureCode, type UnitSystem } from '@icommerce/units';
import { getIcommerceUnitSystemName } from '@hub/bearing-hub/common/useUnitSystem/useUnitSystem';

interface TemperatureRangeSectionProps {
  setFilterValue: (key: IbhFilterKeys, value: string | string[] | number | boolean | undefined | IbhDimensions) => void;
  tempratureRangeValues: (number | null)[];
  isCollapsible?: boolean;
  unitSystem: UnitSystem;
}

export const TemperatureRangeSection = ({
  setFilterValue,
  tempratureRangeValues,
  isCollapsible = false,
  unitSystem,
}: TemperatureRangeSectionProps) => (
  <FilterRangeInput
    key={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.TEMPERATURE_RANGE_MIN}${
      tempratureRangeValues[0] !== null ? tempratureRangeValues[0] : 'null'
    }_${IbhFilterKeys.TEMPERATURE_RANGE_MAX}${tempratureRangeValues[1] !== null ? tempratureRangeValues[1] : 'null'}`}
    id={`filter_${IbhFilterKeys.TEMPERATURE_RANGE_MIN}_${IbhFilterKeys.TEMPERATURE_RANGE_MAX}`}
    values={tempratureRangeValues}
    min={null}
    max={null}
    unit={getUnitLabelForUnitSystem(TemperatureCode.CELSIUS, getIcommerceUnitSystemName(unitSystem))}
    onChange={newValues => {
      const [min, max] = newValues;
      if (min !== null && typeof min !== 'undefined') {
        setFilterValue(IbhFilterKeys.TEMPERATURE_RANGE_MIN, min);
      } else {
        setFilterValue(IbhFilterKeys.TEMPERATURE_RANGE_MIN, undefined);
      }
      if (max !== null && typeof max !== 'undefined') {
        setFilterValue(IbhFilterKeys.TEMPERATURE_RANGE_MAX, max);
      } else {
        setFilterValue(IbhFilterKeys.TEMPERATURE_RANGE_MAX, undefined);
      }
    }}
  />
);
